import CrudList from "@/pages/admin/CrudList";
export default function AdminCategories() {
    return <CrudList endpoint="/admin/categories" title="Categorias" subtitle="Taxonomia" testPrefix="category" />;
}
